
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 14.08H2.344a.469.469 0 01-.469-.468V8.455A5.625 5.625 0 017.5 2.83h0a5.625 5.625 0 015.625 5.625v0A5.625 5.625 0 017.5 14.08v0z","stroke":"#050A16","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.195 14.08a5.627 5.627 0 005.305 3.75h5.156a.469.469 0 00.47-.469v-5.156a5.626 5.626 0 00-5.319-5.617","stroke":"#050A16","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    